import bugsnag from "@bugsnag/js";
import produce from "immer";
import { CustomizationState } from "..";
import { findColorDefinition, findPageAndDefinition } from "../../../utils/customization/finders";

export interface ChangePageColorDefinitionAction {
  type: "changePageColorDefinition";
  colorDefinitionKey: string;
  pageKey: string;
}

export function changePageColorDefinition(
  state: CustomizationState,
  action: ChangePageColorDefinitionAction
): CustomizationState {
  return produce(state, (draftState) => {
    const { content, template } = draftState;
    const { colorDefinitionKey, pageKey } = action;

    const colorDefinition = findColorDefinition(colorDefinitionKey, template.colorDefinitions);
    if (!colorDefinition) {
      bugsnag.notify(new Error(`colorDefinition for key ${colorDefinitionKey} not found`));
      return;
    }

    draftState.ui.defaultColorKey = colorDefinitionKey;

    const { page, pageDefinition } = findPageAndDefinition(pageKey, draftState.template, content);
    if (pageDefinition.backgroundColorKeys.includes(colorDefinitionKey) === false) {
      return;
    }

    page.backgroundColorKey = colorDefinition.key;
  });
}
